import { Controller } from "@hotwired/stimulus"
import { soundOn, setSound, chime } from "../lair/chime.js"

// The masthead's speaker toggle. One button, one preference, persisted: sound
// is a taste, not a setting to hunt for. Persisted twice — in the browser, so
// a signed-out page agrees, and on the account (AccountsController#sound), so
// the choice follows the keeper to their next device.
export default class extends Controller {
  connect() {
    this.paint()
  }

  toggle() {
    const on = setSound(!soundOn())
    this.paint()
    this.persist(on)
    // Turning sound on says so audibly — proof and confirmation in one.
    if (on) chime("care")
  }

  paint() {
    const on = soundOn()
    // In the menu the button carries an icon beside its word; only the word changes.
    const label = this.element.querySelector("[data-sound-label]") || this.element
    label.textContent = on ? "Sound on" : "Sound off"
    this.element.setAttribute("aria-pressed", on ? "true" : "false")
    this.element.classList.toggle("ll-navlink--quiet", !on)
    this.element.classList.toggle("ll-menu__item--quiet", !on)
  }

  // Told to the account. The meta the layout writes carries the address; a
  // signed-out page has none, and keeps the choice in the browser alone. A
  // failure is not reported: the button already says what the keeper chose,
  // and the next page will carry the account's word either way.
  persist(on) {
    const url = document.querySelector('meta[name="ll-sound"]')?.dataset.url
    if (!url) return

    fetch(url, {
      method: "PATCH",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
      },
      body: JSON.stringify({ on: on ? "1" : "0" }),
      credentials: "same-origin"
    }).catch(() => {})
  }
}
